var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgF2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9301 3.91216C17.9057 3.87556 17.8731 3.83896 17.8447 3.80643C16.0106 1.48841 13.1761 0 10 0C4.48556 0 0 4.48556 0 10C0 15.5144 4.48556 20 10 20C15.5144 20 20 15.5144 20 10C20 7.71045 19.2273 5.59984 17.926 3.91216H17.9301ZM10 17.56C5.83164 17.56 2.44002 14.1684 2.44002 10C2.44002 5.83164 5.83164 2.44002 10 2.44002C12.0211 2.44002 13.8552 3.24115 15.2135 4.53843L10 9.75193L7.90972 7.66165C7.43392 7.18585 6.66124 7.18585 6.18544 7.66165C5.70964 8.13745 5.70964 8.91013 6.18544 9.38593L9.13786 12.3383C9.3778 12.5783 9.68687 12.6962 10 12.6962C10.3131 12.6962 10.6263 12.5783 10.8621 12.3383L16.6978 6.50264C17.2469 7.54778 17.56 8.73526 17.56 10C17.56 14.1684 14.1684 17.56 10 17.56Z",
    fill: "#ba120e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF2);
export default __webpack_public_path__ + "static/media/f2.1d9857fc6f5b5fe61516e60519862418.svg";
export { ForwardRef as ReactComponent };